import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function AiMessage(props) {
  const { visible = false, text } = props;
  if (!visible) {
    return null;
  }
  return (
    <div className={classNames('chat-message-ai-wrapper', 'flex')}>
      <span className="chat-message-ai-icon icon-ai-chat-bubble"></span>
      <div className={classNames('chat-message-ai', 'flex-1')}>{text}</div>
    </div>
  );
}

AiMessage.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  visible: PropTypes.bool,
};

export default AiMessage;
